import { useEffect, useState } from "react"
import "./styles/project-management.css"
import ProjectManagementFilter from './components/ProjectManagementFilter'
import ProjectManagementMainSection from './components/ProjectManagementMainSection'
import useProjectManagementHook from './hooks/useProjectManagementHook';

const ProjectManagement = () => {
  const { handler } = useProjectManagementHook();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      setIsLoading(true);
      try {
        await handler.handleGetProjects();
      } catch (error) {
        console.error('Error fetching projects:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchProjects();
  }, []);


  return (
    <div className="container-fluid project-mgmt-page">
      <div className="row">
        <div className="col-12 mt-2">
          <ProjectManagementFilter />
        </div>
        <div className="col-12 mt-2">
          <ProjectManagementMainSection isLoading={isLoading} />
        </div>
      </div>
    </div>
  )
}
export default ProjectManagement;